import * as React from 'react';
import { Link } from 'react-router-dom';
import Main from '../../BrowserSupport/Main';
import I18nTitle from '../../Title/I18nTitle';
import { T } from '../../Translations';

const Sitemap: React.FC = () => {
  const linkClassName =
    'block py-2 text-lg text-teal-600 hover:text-teal-700 hover:underline focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2';

  return (
    <>
      <I18nTitle title="Sitemap" />
      <Main id="main" className="mx-auto max-w-4xl px-6 py-8 md:px-12">
        <h1 className="mb-6 text-3xl font-semibold text-gray-900">
          <T kind="Sitemap" />
        </h1>

        <nav aria-label="Site navigation">
          <ul className="space-y-2">
            <li>
              <Link className={linkClassName} to="/">
                <T kind="Dashboard" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/calendar">
                <T kind="Calendar" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/team">
                <T kind="Team" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/program_chat">
                <T kind="Program" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/communities">
                <T kind="Communities" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/resources">
                <T kind="Resources" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/notes">
                <T kind="Notes" />
              </Link>
            </li>
            <li>
              <Link className={linkClassName} to="/profile/edit">
                <T kind="Edit Profile" />
              </Link>
            </li>
          </ul>
        </nav>
      </Main>
    </>
  );
};

export default Sitemap;
